/**
 * The privacy policy before sign-in (no router hooks — these screens render outside the router):
 * - <PrivacyLink>: a button that opens the policy in a sheet (sign-in, invite link, onboarding consent).
 * - <PublicPrivacyScreen>: /privacy opened directly while signed out or still onboarding.
 */
import { ChevronLeft, ShieldCheck } from 'lucide-react';
import { useState } from 'react';
import { Button, Card, Sheet, cx } from '../../components/ui';
import { useT } from '../../i18n';
import { AuthLayout } from '../auth/AuthLayout';
import { PrivacyPolicy } from './PrivacyPolicy';

export function PrivacyLink({ label, className }: { label?: string; className?: string }) {
  const t = useT();
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant="ghost" icon={ShieldCheck} className={cx('text-left', className)} onClick={() => setOpen(true)}>
        {label ?? t('settings.privacy.title')}
      </Button>
      <Sheet open={open} onClose={() => setOpen(false)} title={t('settings.privacy.title')} wide>
        <div className="py-2">
          <PrivacyPolicy flat />
        </div>
      </Sheet>
    </>
  );
}

export function PublicPrivacyScreen({ onClose }: { onClose: () => void }) {
  const t = useT();
  return (
    <AuthLayout
      wide
      topLeft={
        <Button variant="ghost" icon={ChevronLeft} onClick={onClose} className="-ml-2">
          {t('common.back')}
        </Button>
      }
    >
      <h1 className="mb-5 text-center text-[28px] leading-tight font-bold tracking-tight">{t('settings.privacy.title')}</h1>
      <Card className="px-5 py-6 md:px-8 md:py-8">
        <PrivacyPolicy flat />
      </Card>
    </AuthLayout>
  );
}
